<template>
  <a :href="twitterUrl" target="_blank" rel="noopener noreferrer">
    <span class="icon is-small">
      <i class="mdi mdi-twitter"></i>
    </span>
  </a>
</template>

<script>
export default {
  name: 'twitterLink',
  props: {
    twitterHandle: {
      type: String,
      default: ''
    }
  },
  computed: {
    twitterUrl () {
      return `https://twitter.com/${this.twitterHandle}`
    }
  }
}
</script>
